import Effects from './Effects.js';
import Preset from 'repos/Preset.js';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import {AudioParamValueParameter,
        AbstractAudioParamParameter,
        } from 'parameters/AbstractAudioParamParameter.js';
import ParameterContext from "effects/ParameterContext.js";
import Tone from 'tone';
import FormantsOscillator from "instruments/synth/oscillator/FormantsOscillator.js";

export default class MultiFilter extends FormantsOscillator(Effects.Effect) {
    constructor(sequencerEngine) {
        super('Multi Filter', () => new Tone.Gain(1), sequencerEngine); 
        this.context = new ParameterContext().forEffect(this);
        this.preset = new Preset();
        this.setupFormants();
        this.track = {
            sequencerEngine
        };

        this.crossFade = new Tone.CrossFade(1);
        this.wetParameter = new AudioParamValueParameter(
            'Wet', this.crossFade.fade, {
                documentation: "Controls the amount of (wet) effected signal, vs. dry (un-effected) signal.",
                defaultValue: 0.5,
                min: 0,
                max: 1});

        this.registerParameter(this.wetParameter);

        this.gainParameter = new AudioParamValueParameter(
            'Output Gain', this.formantsManager.output.gain, {
                defaultValue: 1,
                min: 0,
                max: 4
            });
        this.registerParameter(this.gainParameter);

        this.effectNode.connect(this.formantsManager.input);
        this.outputNode = new Tone.Gain(1);
        //this.formantsManager.output.connect(this.outputNode);

        this.effectNode.connect(this.crossFade, 0, 0);
        this.formantsManager.output.connect(this.crossFade, 0, 1);
        this.crossFade.connect(this.outputNode);
    }

    getJson(...args ) {
        let json = {
            ... super.getJson(...args),
            gain: this.gainParameter.get(true),
            multiFilter: this.getFormantsJson()
        };

        json = this.saveParameterToJson(json, 'gainParameter', this.gainParameter);
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        if ('gain' in json) {
            bulkUpdate(this.gainParameter, json.gain, bulk);
        }
        return {
            ... bulk,
            ... this.loadFormantsJson(json.multiFilter, isCopy),
            ... this.loadParameterFromJson(json, 'gainParameter', this.gainParameter, isCopy),
        };
    }

    connect(o) {
        this.outputNode.connect(o);
    }

    disconnect() {
        this.outputNode.disconnect();
    }
}
